module.exports = __webpack_public_path__ + "static/media/96.989a3de3.png";